import {DateTime} from "luxon";
import {container, injectable} from "tsyringe";
import {transformer} from "../decorators/transformer.decorator";
import {EmployeeDTO} from "../domain/dtos/employee.dto";
import {Employee} from "../domain/entities/employee.entity";
import {AbstractDtoToEntityTransformer} from "./abstract-dto-to-entity.transformer";
import {WeeklyWorkingTimeRepository} from "../domain/repositories/weekly-working-time.repository";
import {ShortIdHelper} from "../helpers/short-id.helper";

@injectable()
@transformer({
    source: `dto`,
    target: Employee
})
export class DtoToEmployeeTransformer extends AbstractDtoToEntityTransformer<EmployeeDTO, Employee> {

    protected toEntity(dto: EmployeeDTO): Promise<Employee> {

        const employee = new Employee();
        const weeklyWorkingTimeRepository = container.resolve(WeeklyWorkingTimeRepository);
        const weeklyWorkingTime = dto.weeklyWorkingTime
            ? container.resolve(WeeklyWorkingTimeRepository)
                .findOneById(dto.weeklyWorkingTime)
                .then(weeklyWorkingTime => weeklyWorkingTime ?? weeklyWorkingTimeRepository.create(employee))
            : weeklyWorkingTimeRepository.create(employee)!;

        return Promise.resolve(
            Object.assign(
                employee,
                {
                    uid: dto.uid ?? ShortIdHelper.generate(),
                    firstName: dto.firstName,
                    lastName: dto.lastName,
                    shortcut: dto.shortcut ?? ``,
                    color: dto.color ?? `#ffffff`,
                    deletedAt: !!dto.deletedAt ? DateTime.fromSQL(dto.deletedAt) : null,
                    weeklyWorkingTime
                }
            )
        );
    }
}